import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { getInvoiceDaysOverdue } from "@common/helpers/invoice-days-overdue";
import { Invoice } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useUTCTodayDateOnly } from "@hooks/useUTCTodayDateOnly";

export const DaysOverdueCell = memo(
    ({ row }: CellContext<ViewTableFeatures, Invoice, string | null>) => {
        const todayDateOnly = useUTCTodayDateOnly();
        const daysOverdue = getInvoiceDaysOverdue(row.original, todayDateOnly);
        return (
            <ViewTableCell>{daysOverdue > 0 ? daysOverdue : ""}</ViewTableCell>
        );
    },
);
